import { INDICATOR_OPTIONS } from '@/components/Chart/IndicatorSelector.tsx';
import type { HexColor, IndicatorInput } from '@einhaus/project314-types';

// TODO - track all used colors and pass them in here to avoid duplicates?
export const assignColorsToIndicator = (indicator: IndicatorInput, usedColors: HexColor[]) => {
    // Find the indicator option, it might have default colors
    const foundIndicator = INDICATOR_OPTIONS.find((option) => option.type === indicator.type);

    if (foundIndicator && 'defaultColors' in foundIndicator) {
        return foundIndicator.defaultColors!;
    }

    const popColors: HexColor[] = ['#FFEB00', '#FFFFFF', '#FF9700', '#00DAFF', '#0049FF', '#FF00E9'];

    let foundUnusedColor: HexColor | null = null;

    while (!foundUnusedColor) {
        const randomColor = popColors[Math.floor(Math.random() * popColors.length)];

        if (!usedColors.includes(randomColor)) {
            foundUnusedColor = randomColor;
        }
    }

    return foundUnusedColor ? [foundUnusedColor] : [popColors[Math.floor(Math.random() * popColors.length)]];
};
